/* eslint-disable max-len */

import PouchDB from "pouchdb";
import { getSalesforceConnection } from "../utils/getSalesforceConnection";
import { isUnauthorized } from "../utils/salesforce";

import { get, upsert } from "./common";

const CUSTOMERS = "XXSCustomers";

const soql =
  "select id, shipmentmethoddescription__c, agentdescription__c, name, name2__c, vatid__c, Sales_Person_Code__c, AgentNo__c, PaymentTerms__c, AssociationCode__c, AssociationMemberNo__c, SalespersonEmail__c, SalespersonPhone__c, BillToCustomerNo__c, SalespersonName__c, billingstreet, billingcity, billingcountry, billingpostalcode, CustomerNo__c, CustomerPriceGroup__c, LowaGroup__c, Customer_No_blocked_Text__c, blocked__c from account where blocked__c in (0, 1)";

const mapDataToInsert = (data) =>
  data.map((d) => ({
    ...d,
    _id: d.Id,
  }));

class Customers {
  constructor(name) {
    this.db = new PouchDB(name);
  }

  load = (callback) => get({ key: CUSTOMERS, db: this.db, callback });

  save = (products, onSuccess) =>
    upsert(this.db, CUSTOMERS, mapDataToInsert(products), onSuccess);

  fetchFromSalesforceAndSave = async ({ credentials, onSuccess, onError }) => {
    let retries = 0;

    const inner = async () => {
      if (retries === 5) {
        throw new Error("Max out retries");
      }
      try {
        let done = false;
        let finalData = [];
        let locator = "";
        const connection = await getSalesforceConnection(
          credentials,
          retries > 0,
        );

        const data = await connection.queryAll(soql);
        finalData = [...finalData, ...data.records];
        done = data.done;
        locator = data.nextRecordsUrl;
        while (!done) {
          const moreData = await connection.queryMore(locator);
          finalData = [...finalData, ...moreData.records];
          locator = moreData.nextRecordsUrl;
          done = moreData.done;
        }

        this.save(finalData);
        onSuccess();
      } catch (error) {
        if (isUnauthorized(error)) {
          retries++;
          const data = await inner();
          return data;
        } else {
          onError(error);
        }
      }
    };

    await inner();
  };
}

export default Customers;
